import React from 'react';

import styled from 'styled-components';

import { canManageShopperEmails, canViewRingCentralRecords } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import SidebarMenuCategoryHeader from './SidebarMenuCategoryHeader';
import SidebarMenuItem from './SidebarMenuItem';

const Container = styled.div`
  padding-top: 20px;
`;

const SidebarMenuMysteryShopping = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const showShopperEmails = canManageShopperEmails(currentUser);
  const showRingCentralRecords = canViewRingCentralRecords(currentUser);

  return (
    <Container>
      <SidebarMenuCategoryHeader title={'MYSTERY SHOPPING'} />
      <SidebarMenuItem to={`/mystery-shopping`} label="Shop Requests" />
      {showShopperEmails && <SidebarMenuItem to={`/mystery-shopping/shopper-emails`} label="Shopper Contacts" />}
      {showRingCentralRecords && (
        <SidebarMenuItem to={`/mystery-shopping/ringcentral-records`} label="RingCentral Records" />
      )}
    </Container>
  );
};

export default SidebarMenuMysteryShopping;
